import React, { useState } from 'react';
import AdvancedSettingsButton from '../../formBuilder/FormElements/elements/buttons/AdvancedSettingsButton';


const AdditionOptionsContainer = ({defaultAdvancedSettings = false, children}:{defaultAdvancedSettings: boolean, children: React.JSX.Element}) => {
    const [showAdvancedOptions, setShowAdvancedOptions] = useState<boolean>(defaultAdvancedSettings)
    
    return (
        <div className='collapsable-options-container'>
            {showAdvancedOptions && children}
            <AdvancedSettingsButton showAdvancedOptions={showAdvancedOptions} setShowAdvancedOptions={() => setShowAdvancedOptions(!showAdvancedOptions)}/>
        </div>
    );
};

export default AdditionOptionsContainer